import React, {useEffect}  from 'react'
import {useHistory} from 'react-router-dom'
import Joyride from 'react-joyride';
import Icons from '../Icons'
import css from './Tour.module.scss';
import lCss from '../../Layout/Layout.module.scss'
import {TourContext, ModalContext} from "../../../context";
import {setCookie, scrollTo} from "../../../utils";


const Tour = () => {
	const { tour, dropdownTour, onStepIndex, closeTour } = React.useContext(TourContext)
	const { openModal, closeModal } = React.useContext(ModalContext)
	const history = useHistory()

	const register = () => {
		closeTour()
		openModal('registration')
	}

	const close = () => {
		setCookie('initialTour', '0', 60 * 1000 * 730 * 2 * 365, '/');
		closeTour({
			tour: false
		})
	}

	const tooltipComponent = ({continuous, index, isLastStep, size, step, backProps, closeProps, primaryProps, skipProps, tooltipProps}) => {
		const back = () => {
			if(step.backCallback) {
				step.backCallback()
			} else{
				onStepIndex(index - 1, step.spotlightClicks)
			}
		}

		const next = () => {
			if(step.nextCallback) {
				step.nextCallback()
			} else{
				onStepIndex(index + 1, step.spotlightClicks)
			}
		}

		return (
			<div {...tooltipProps} className={css.tour}>
				<div className={css.close} onClick={close}><Icons name={"close"}/></div>
				<div className={css.title}>{step.title}</div>
				<div className={css.content}>{step.content}</div>
				<div className={css.btns}>
					{step.back
						? <div className={css.left + ' ' + ((step.back && (step.next || step.close)) ? css.padding : '')}>
							<button {...backProps} className={lCss.button + ' ' + lCss.w100} onClick={back}>{step.back}</button>
						</div>
						: null
					}
					{step.next
						? <div className={css.right + ' ' + ((step.back && step.next) ? css.padding : '')}>
							<button {...primaryProps} className={lCss.button + ' ' + lCss.w100} onClick={next}>{step.next}</button>
						</div>
						: null
					}
				</div>
				<div className={css.progress}>
					{new Array(size).fill(null).map((e,i) => <span key={i} className={(i === index ? css.active : '')}/>)}
				</div>
			</div>
		)
	}

	return (
		<Joyride
			run={tour.open}
			continuous={true}
			disableOverlayClose={true}
			disableCloseOnEsc={true}
			spotlightClicks={tour.spotlightClicks}
			stepIndex={tour.stepIndex}
			tooltipComponent={tooltipComponent}
			styles={{
				overlay: {
					zIndex: 90
				},
				options: {
					zIndex: 90000
				}
			}}
			steps={[
				{
					placement: 'center',
					target: 'body',
					spotlightClicks: false,
					title: 'Добро пожаловать на обновленный онлайн ресурс РИА Новости. База анонсов!',
					content: 'Все анонсы значимых международных, федеральных и региональных мероприятий на одном сайте. Ежедневное обновление.',
					next: 'Рассказать, что нового?'
				},
				{
					target: '[data-target="auth"]',
					title: 'Авторизуйтесь',
					spotlightClicks: true,
					content: <span> Нет логина и пароля? <span className={css.blue} onClick={register}>Получить тестовый доступ</span></span>,
				},
				{
					target: '[data-target="main"]',
					content: '«Самое важное» — cамые главные события дня в стране и мире',
					spotlightClicks: false,
					placement: 'right-start',
					next: 'Далее'
				},
				{
					target: '[data-target="relevant"]',
					content: '«Актуальные события» — события, которые представляют безусловный интерес для широкого круга пользователей',
					spotlightClicks: false,
					placement: 'right-start',
					back: 'Назад',
					next: 'Далее'
				},
				{
					target: '[data-target="history"]',
					content: '«День в истории» — календарные и памятные даты',
					spotlightClicks: false,
					placement: 'left-start',
					back: 'Назад',
					next: 'Далее',
					nextCallback: () => {
						onStepIndex(tour.stepIndex + 1)
						setTimeout(() => {
							openModal('settings')
						},250)
					}
				},
				{
					target: '[data-target="settings"]',
					content: 'Можно ограничить выдачу выбором категории в настройках',
					spotlightClicks: false,
					placement: 'left-start',
					offset: 425,
					back: 'Назад',
					next: 'Далее',
					backCallback: () => {
						closeModal()
						onStepIndex(tour.stepIndex - 1)
					},
					nextCallback: () => {
						closeModal()
						onStepIndex(tour.stepIndex + 1)
					}
				},
				{
					target: '[data-target="filters"]',
					content: 'Фильтры расширенного поиска: по дате или диапазону дат, ключевому слову и категории',
					back: 'Назад',
					next: 'Далее',
					spotlightClicks: false,
					backCallback: () => {
						onStepIndex(tour.stepIndex - 1)
						setTimeout(() => {
							openModal('settings')
						},250)
					},
					nextCallback: () => {
						dropdownTour(true)
						setTimeout(() => {
							onStepIndex(tour.stepIndex + 1)
							setTimeout(()=>{
								let dropdown = document.querySelectorAll('[data-target="categories-dropdown"]')
								let list  = document.querySelectorAll('[data-target="categories-dropdown"] div[data-list_id="53"]')
								if (dropdown.length && list.length) {
									let top = list[0].offsetTop
										scrollTo(dropdown[0], top, 300)
								}
							}, 200)
						}, 0)
					}
				},
				{
					target: '[data-target="categories"]',
					content: 'При выборе категории «Онлайн» в выдаче появляются анонсы мероприятий в онлайн формате. В категории «Онлайн+» добавляется и очный формат.',
					back: 'Назад',
					next: 'Далее',
					spotlightClicks: true,
					placement: 'right',
					backCallback: () => {
						dropdownTour(false)
						onStepIndex(tour.stepIndex - 1)
					},
					nextCallback: () => {
						dropdownTour(false)
						onStepIndex(tour.stepIndex + 1)
					}
				},
				{
					target: '[data-target="main-event"]',
					content: 'Здесь Вы можете прочесть полное описание события',
					backCallback: () => {
						dropdownTour(true)
						setTimeout(() => {
							onStepIndex(tour.stepIndex - 1)
							setTimeout(()=>{
								let dropdown = document.querySelectorAll('[data-target="categories-dropdown"]')
								let list  = document.querySelectorAll('[data-target="categories-dropdown"] div[data-list_id="53"]')
								if (dropdown.length && list.length) {
									let top = list[0].offsetTop
									scrollTo(dropdown[0], top, 300)
								}
							}, 200)
						}, 0)
					},
					nextCallback: () => {
						if (document.querySelectorAll('[data-target="main-event"] a').length) {
							closeTour()
							onStepIndex(tour.stepIndex + 1)
							history.push({pathname: document.querySelectorAll('[data-target="main-event"] a')[0].getAttribute('href')})
						}
					},
					placement: 'right',
					spotlightClicks: true,
					back: 'Назад',
					next: 'Далее'
				},
				{
					target: '[data-target="share"]',
					content: 'Удобно работать с текстом анонса: можно копировать и пересылать по электронной почте.',
					spotlightClicks: true,
					placement: 'right',
					backCallback: () => {
						history.goBack()
						setTimeout(() => {
							onStepIndex(tour.stepIndex - 1)
						}, 100);
					},
					nextCallback: () => close(),
					back: 'Назад',
					next: 'Закрыть'
				}
			]}
		/>
	)
}

export default Tour